module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/adminManager/templates/users/User.ejs -->\n<td>'+
((__t=( model.id ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('username') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('role') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('createdAt') ))==null?'':_.escape(__t))+
'</td>\n<td>\n    ';
 if (model.get('role') === 'employer') { 
__p+='\n        <button class="js-grant-admin btn btn-default float-right">\n            Make Admin\n        </button>\n    ';
 } else if (model.get('role') === 'admin_manager') { 
__p+='\n        <button class="js-revoke-admin btn btn-default float-right">\n            Revoke Admin Access\n        </button>\n    ';
 } 
__p+='\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/adminManager/templates/users/User.ejs
// module id = 637
// module chunks = 1